import { render, staticRenderFns } from "./FollowUpSettings.vue?vue&type=template&id=564a805e&"
import script from "./FollowUpSettings.vue?vue&type=script&lang=js&"
export * from "./FollowUpSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports